<template>
  <b-modal
    id="CreateParameterModal"
    :title="modalTitle"
    size="lg"
    hide-footer
  >
    <b-card>
      <validation-observer ref="FormValidation">
        <b-form
          enctype="multipart/form-data"
          autocomplete="off"
          @submit.prevent="checkValidation"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="t('Status')"
                label-for="vi-status"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Status"
                  vid="vi-status"
                >
                  <v-select
                    v-model="form.status"
                    class="p-0 border-0 w-100"
                    :class="errors[0] ? 'border-red-vselect' : ''"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="label"
                    :placeholder="t('Select Status')"
                    :reduce="s => s.id"
                    :options="statusList"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="t('Para Value')"
                label-for="vi-para_value"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Para Value"
                  vid="vi-para_value"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="vi-para_value"
                      v-model="form.para_value"
                      type="text"
                      :class="errors[0] ? 'border-red' : ''"
                      :placeholder="t('Enter Para Value')"
                    />
                  </b-input-group>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="t('Para Description')"
                label-for="vi-para_desc"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Para Description"
                  vid="vi-para_desc"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="vi-para_desc"
                      v-model="form.para_desc"
                      type="text"
                      :class="errors[0] ? 'border-red' : ''"
                      :placeholder="t('Enter Para Description')"
                    />
                  </b-input-group>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="t('Para Tech Description')"
                label-for="vi-para_tech_desc"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Para Tech Description"
                  vid="vi-para_tech_desc"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="vi-para_tech_desc"
                      v-model="form.para_tech_desc"
                      type="text"
                      :class="errors[0] ? 'border-red' : ''"
                      :placeholder="t('Enter Para Tech Description')"
                    />
                  </b-input-group>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="t('Select Parent Parameter')"
                label-for="vi-para_parent_id"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Select Parent Parameter"
                  vid="vi-para_parent_id"
                >
                  <v-select
                    v-model="form.para_parent_id"
                    class="p-0 border-0 w-100"
                    :class="errors[0] ? 'border-red-vselect' : ''"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="para_value"
                    :placeholder="t('Select Parent Parameter')"
                    :reduce="s => s.para_id"
                    :options="AllParentParameterList"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="text-center"
            >
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ t('Submit') }}
              </b-button>
              <b-button
                type="button"
                variant="outline-secondary"
                @click="modalCancel"
              >
                {{ t('Cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { useUtils } from '@core/libs/i18n'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import constants from '@/constants'
import { hideLoader, showLoader } from '@/utils/common'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: ['parameterData'],
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      openModal: false,
      modalTitle: '',
      modalData: [],
      statusList: [],
      AllParentParameterList: [],

      form: {
        // para_id: null,
        para_value: null,
        para_desc: null,
        para_tech_desc: null,
        para_parent_id: null,
        status: 1,
      },
    }
  },
  watch: {
    parameterData: {
      handler(val) {
        this.modalTitle = val.name
        this.modalData = val
        this.openModal = true
        this.form.status = this.modalData.status
        this.form.para_value = this.modalData.para_value
        this.form.para_desc = this.modalData.para_desc
        this.form.para_tech_desc = this.modalData.para_tech_desc
        this.form.para_parent_id = this.modalData.para_parent_id
        this.form.para_id = this.modalData.para_id
      },
    },
  },
  mounted() {
    this.statusList = constants.StatusList2
    this.$root.$on('bv::modal::hidden', (a, componentId) => {
      if (componentId === 'CreateParameterModal') {
        this.openModal = false
        this.form = {
          para_id: null,
          para_value: null,
          para_desc: null,
          para_tech_desc: null,
          para_parent_id: null,
          status: 1,
        }
      }
    })
    this.getParentParameter()
  },
  methods: {
    async onSubmit() {
      showLoader()
      await store.dispatch('storeSetting/CreateParameter', this.form).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.$bvModal.hide('CreateParameterModal')
          // this.$root.$emit('refreshLeadData')
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: '',
            },
          })
          this.$root.$emit('refreshPolymerTypeList')
          this.$refs.FormValidation.reset()
        } else {
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      }).catch(e => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: e.msg,
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
    modalCancel() {
      this.$bvModal.hide('CreateParameterModal')
    },
    checkValidation() {
      this.$refs.FormValidation.validate().then(success => {
        if (success) {
          this.onSubmit()
        }
      })
    },
    async getParentParameter() {
      await store.dispatch('storeSetting/getAllParentParameter')
        .then(response => {
          if (response.data.code === '200') {
            this.AllParentParameterList = response.data.data
          }
        })
    },
  },
}
</script>
